import React from 'react';
import { getFullName } from '../utils/getFullName';
import { getOrganizationsWithSelectedOnTop } from '../../Login/utils/getOrganizationsWithSelectedOnTop';

function AccountMenu({
    meData,
    organizationData,
    dashboardPageUrl,
    resourcedTexts,
    selectedOrganizationId,
    handleOrganizationClick,
    handleMenuClose,
    handleSignOutClick,
}) {
    const { firstName, middleName, lastName, email } = meData;
    const fullName = getFullName(firstName, middleName, lastName);
    const organizations = organizationData ? organizationData.organizations : [];

    const sortedOrganizations = getOrganizationsWithSelectedOnTop(organizations, selectedOrganizationId);

    return (
        <>
            <div className="account-menu-page-blocker" onClick={handleMenuClose} />

            <article className="account-menu">
                {fullName && <span className="account-menu__name">{fullName}</span>}
                <span className="account-menu__email">{email}</span>

                <a href={dashboardPageUrl} className="button account-menu__button">
                    {resourcedTexts.dashboardButton}
                </a>

                <ul className="account-menu__list">
                    {sortedOrganizations.map(({ id, name }) => {
                        const isSelected = id === selectedOrganizationId;
                        return (
                            <li key={id} className={isSelected ? 'active' : ''}>
                                <a href="#" onClick={(e) => handleOrganizationClick(e, id)}>
                                    {name}
                                </a>
                            </li>
                        );
                    })}
                </ul>

                <button className="button account-menu__button" type="button" onClick={handleSignOutClick}>
                    {resourcedTexts.logoutButton}
                </button>
            </article>
        </>
    );
}

export { AccountMenu };
